export default "/images/20af525086fb3e988c7c46a72e065604.png";